/**
 * Quill 2 (react-quill-new) emits &nbsp; for ordinary typed spaces (its
 * getSemanticHTML() backs the onChange value), so saved HTML renders as ONE
 * unbreakable line wherever it is displayed: the public release-statement
 * step, the waiver signing card, block content.
 *
 * An nbsp directly before a visible character is an ordinary word gap, and
 * converting it to a plain space is visually identical while restoring
 * wrapping. Nbsp runs used for padding/alignment (followed by another nbsp
 * or a space) are left alone. Never do a broad replace-all-nbsp; that would
 * destroy deliberate padding.
 *
 * Apply it at BOTH ends: every admin Quill save boundary (WaiverAdmin,
 * RichtextBlockEditor, the registration Legal section) and the public
 * renderers (RegistrationReleaseStatement, PlayerWaiverCard), because
 * content saved before a boundary had the strip is still in the database
 * (ocsabasketball's release statement, 2026-10-16).
 */
export function stripQuillNbsp(html: string | null | undefined): string {
  return (html || '').replace(/&nbsp;(?=\S)/g, ' ');
}
